
      var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 39.8,
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.594 37.128a2.475 2.475 0 1 1 4.284 2.482L62.321 64.74a2.475 2.475 0 0 1-4.284-2.482l14.557-25.13z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.876 57.36a2.477 2.477 0 1 1 2.469-4.296l14.771 8.488a2.477 2.477 0 1 1-2.469 4.296l-14.771-8.489z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.73 27.971a1.98 1.98 0 1 1 3.96.02l-.02 4.038a1.98 1.98 0 1 1-3.96-.02l.02-4.038zm0 60a1.98 1.98 0 1 1 3.96.02l-.02 4.038a1.98 1.98 0 1 1-3.96-.02l.02-4.038zM92.029 57.73a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02zm-60 0a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"60\" cy=\"60\" r=\"39.8\" stroke=\"#000000\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M72.594 37.128a2.475 2.475 0 1 1 4.284 2.482L62.321 64.74a2.475 2.475 0 0 1-4.284-2.482l14.557-25.13z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M43.876 57.36a2.477 2.477 0 1 1 2.469-4.296l14.771 8.488a2.477 2.477 0 1 1-2.469 4.296l-14.771-8.489z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.73 27.971a1.98 1.98 0 1 1 3.96.02l-.02 4.038a1.98 1.98 0 1 1-3.96-.02l.02-4.038zM57.73 87.971a1.98 1.98 0 1 1 3.96.02l-.02 4.038a1.98 1.98 0 1 1-3.96-.02l.02-4.038zM92.029 57.73a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02zM32.029 57.73a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02z\" fill=\"#000000\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/clock-icon.d385b2b2ebd566b0818d0336be037c97.svg"),
        {
          React: SvgClockIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      